import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card, PageHeader, Btn, Modal, Input, Select, StatusBadge, EmptyState } from "@/components/admin/ui";

export default function AdminNotifications() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", message: "", priority: "normal", audience: "global" });

  const load = useCallback(() => { api.get("/notifications").then((r) => setItems(r.data.items)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const send = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/announcements", form); toast.success(data.message); setOpen(false); setForm({ title: "", message: "", priority: "normal", audience: "global" }); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const markRead = async () => { await api.post("/notifications/read"); load(); toast.success("Marked all read"); };

  return (
    <div className="space-y-6">
      <PageHeader title="Notifications & Announcements" subtitle="System notifications and broadcast center"
        action={<div className="flex gap-2"><Btn variant="ghost" onClick={markRead}>Mark all read</Btn><Btn data-testid="send-announcement-btn" onClick={() => setOpen(true)}>+ Announcement</Btn></div>} />
      <Card>
        {items.length === 0 ? <EmptyState title="No notifications" desc="System events and announcements will appear here." /> : (
          <div className="divide-y divide-white/5">
            {items.map((n) => (
              <div key={n.id} className="p-4 flex items-start justify-between gap-4" data-testid={`notif-${n.id}`}>
                <div>
                  <div className="flex items-center gap-2"><span className="font-medium text-white">{n.title}</span>{!n.read_at && <span className="h-2 w-2 rounded-full bg-[#1D4ED8]" />}</div>
                  <div className="text-sm text-slate-400 mt-0.5">{n.message}</div>
                  <div className="text-xs text-slate-600 mt-1">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
                </div>
                <StatusBadge status={n.type?.replace(/_/g, " ")} />
              </div>
            ))}
          </div>
        )}
      </Card>

      <Modal open={open} onClose={() => setOpen(false)} title="Send Announcement">
        <form onSubmit={send} className="space-y-3">
          <Input label="Title" data-testid="announce-title" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <div>
            <label className="text-xs font-medium text-slate-400 uppercase tracking-wider">Message</label>
            <textarea required rows={3} data-testid="announce-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="mt-1 w-full px-3 py-2 rounded-lg bg-[#0B0F19] border border-white/10 text-white text-sm focus:border-[#1D4ED8] outline-none" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Select label="Audience" value={form.audience} onChange={(e) => setForm({ ...form, audience: e.target.value })}>
              <option value="global">Global</option>
            </Select>
            <Select label="Priority" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}>
              <option value="normal">Normal</option><option value="high">High</option>
            </Select>
          </div>
          <Btn data-testid="announce-submit" className="w-full">Broadcast</Btn>
        </form>
      </Modal>
    </div>
  );
}
